import * as React from 'react';
import { Translate } from '../../../../../../shared/LanguageService';
import history from '../../../../../../shared/history';
import BaseTab from './BaseTab';

type PhotographerCalendarTabProps = {
    label: string;
};

const PhotographerCalendarRoute = '/photographercalendar';

let routes = [PhotographerCalendarRoute];

function PhotographerCalendarTab({ label, ...props }: PhotographerCalendarTabProps) {
    function handleClick() {
        history.push(PhotographerCalendarRoute);
    }

    return (
        <BaseTab {...props} onClick={handleClick} label={label} route={PhotographerCalendarRoute} />
    );
}

function TranslatedPhotographerCalendarTab(props) {
    const label = Translate('header/nav/calendar');
    return <PhotographerCalendarTab {...props} label={label} />;
}

TranslatedPhotographerCalendarTab.routes = routes;

export default TranslatedPhotographerCalendarTab;
